import { useCallback, useRef, useState } from "react";
import { ControlButton } from "./ControlButton";
import Icon from "app/components/shared/Icon";
import { useHotkeys } from "react-hotkeys-hook";

export const Fullscreen = ({ selector = "#canvas" }) => {
  const el = useRef(document.querySelector<HTMLDialogElement>(selector));
  const [isFullscreen, setIsFullscreen] = useState(false);

  useHotkeys("Escape", () => {
    if (isFullscreen) {
      toggleFullscreen();
    }
  });

  const toggleFullscreen = useCallback(() => {
    if (!el.current) {
      console.warn("Canvas element not found");
      return;
    }

    const nextState = !isFullscreen;
    setIsFullscreen(nextState);

    if (el.current) {
      el.current.dataset.fullscreen = nextState.toString();

      // Set z-index to 30 when entering fullscreen, remove when exiting
      if (nextState) {
        el.current.style.zIndex = "30";
      } else {
        el.current.removeAttribute("style");
      }

      el.current.setAttribute("aria-expanded", nextState.toString());
    }
  }, [isFullscreen]);

  return (
    <ControlButton
      onClick={toggleFullscreen}
      label={isFullscreen ? "Shrink" : "Expand"}
      aria-pressed={isFullscreen}
    >
      <Icon
        icon={
          isFullscreen
            ? "heroicons/solid/arrows-pointing-in"
            : "heroicons/solid/arrows-pointing-out"
        }
        className="h-4 w-5"
      />
    </ControlButton>
  );
};
